import { AxiosResponse } from 'axios';
import { api } from 'services/companiesApi';

export const getPendingAppointments = async (params: {
	employeeId: string;
}): Promise<AxiosResponse> => {
	return await api.get(
		`/employees/${params.employeeId}/has-pending-appointments`,
	);
};

export const postMerge = async (payload: {
	employeeOriginId: string;
	employeeDestinationId: string;
	reason: string;
}): Promise<AxiosResponse> => {
	return await api.post('/employees/merge', payload);
};
